module.exports = __webpack_public_path__ + "img/quanwei.58dfdb05.png";